import { render, staticRenderFns } from "./MedicineCarePlan.vue?vue&type=template&id=8b71ef6c&scoped=true"
import script from "./MedicineCarePlan.vue?vue&type=script&lang=js"
export * from "./MedicineCarePlan.vue?vue&type=script&lang=js"
import style0 from "./MedicineCarePlan.vue?vue&type=style&index=0&id=8b71ef6c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b71ef6c",
  null
  
)

export default component.exports